module.exports = __webpack_public_path__ + "media/images/us_flag_small-be327dc2791d8096d69c7737a1d0a2b8.png";